import ProfileOverviewTab from './ProfileOverviewTab'

export default ProfileOverviewTab
